import React from 'react';
import { Inline, xcss } from '@atlaskit/primitives';
import { ff } from '@atlassian/jira-feature-flagging';
import { useIntl } from '@atlassian/jira-intl';
import { LabelIcon } from '@atlassian/jira-servicedesk-customer-service-common';
import messages from './messages';

type Props = {
	name?: string;
};

export const ReadView = ({ name }: Props) => {
	const { formatMessage } = useIntl();

	return (
		<Inline
			space="space.100"
			alignBlock="center"
			xcss={[
				containerStyles,
				!name && placeholderStyles,
				overflowStyles,
				ff('products-and-entitlements-details-m2_45b1j') && alignmentFixStyles,
			]}
			testId="servicedesk-customer-service-entitlements-field.common.ui.read-view.inline"
		>
			<LabelIcon size="xsmall" type="PRODUCT" />
			{name || formatMessage(messages.entitlementFieldPlaceholder)}
		</Inline>
	);
};

const containerStyles = xcss({
	margin: 'space.050',
});

const placeholderStyles = xcss({
	color: 'color.text.subtlest',
});

const overflowStyles = xcss({
	overflowWrap: 'anywhere',
});

const alignmentFixStyles = xcss({
	// eslint-disable-next-line @atlaskit/design-system/use-latest-xcss-syntax
	paddingLeft: '7px',
});
